import { useRef } from 'react';
var counter = 0;
export function generateUniqueId(prefix) {
    return "" + (prefix ? prefix : '') + counter++ + "-" + Date.now() + "-" + Math.round(Math.random() * 10000);
}
export function useUniqueId(prefix) {
    var idRef = useRef(null);
    if (!idRef.current) {
        idRef.current = generateUniqueId(prefix);
    }
    return idRef.current;
}
